    class LoadMorePosts {
        constructor(block) {
            if (!block || block.dataset.loadmoreInitialized === "true") {
                return;
            }

            this.block = block;
            this.cards = Array.from(block.querySelectorAll('.js-post-card'));
            this.button = block.querySelector('.block-posts__load-more');
            this.cardsPerPage = 6;
            this.currentCount = this.cardsPerPage;

            block.dataset.loadmoreInitialized = "true";

            this.init();
        }

        init() {
            this.hideExtraCards();
            this.bindEvents();

            if (this.cards.length <= this.cardsPerPage) {
                this.cards.forEach(card => card.classList.add('is-visible', 'no-transition'));
                if (this.button) this.button.style.display = 'none';
            }
        }

        hideExtraCards() {
            this.cards.forEach((card, index) => {
                if (index < this.cardsPerPage) {
                    card.classList.add('is-visible', 'no-transition');
                } else {
                    card.classList.add('is-hidden');
                }
            });
        }

        bindEvents() {
            if (!this.button) return;

            this.button.removeEventListener('click', this._boundClick);
            this._boundClick = this.loadMore.bind(this);
            this.button.addEventListener('click', this._boundClick);
        }

        loadMore() {
            const nextCards = this.cards.slice(this.currentCount, this.currentCount + this.cardsPerPage);

            if (nextCards.length === 0) {
                if (this.button) this.button.style.display = 'none';
                return;
            }

            nextCards.forEach(card => {
                card.classList.remove('is-hidden');
                card.classList.add('no-transition');
            });

            requestAnimationFrame(() => {
                nextCards.forEach(card => {
                    card.classList.remove('no-transition');
                    card.classList.add('is-visible');
                });
            });

            this.currentCount += this.cardsPerPage;

            if (this.currentCount >= this.cards.length) {
                if (this.button) this.button.style.display = 'none';
            }
        }
    }

    export default LoadMorePosts;
